import { render, staticRenderFns } from "./english.vue?vue&type=template&id=7b39a530&"
import script from "./english.vue?vue&type=script&lang=js&"
export * from "./english.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports